<template>
  <BaseListCard
    title="Events"
    :parentId="parentId"
    :parentTitle="parentTitle"
    :options="{ 'eventTypes': eventTypes,
                'eventTypesLoading': eventTypesLoading }"
    :entities="entities"
    :entitiesLoading="entitiesLoading"
    :deleteEntity="deleteEntity"
    :emptyEntity="emptyEntity"
    :entitySort="entitySort"
    :deleteDisabled="deleteDisabled"
    ref="baseCard"
  >
    <template v-slot:addForm="{ newEntity, options, entities, stopAdding, entityCreated }">
      <EventForm
        :event="newEntity"
        :eventTypes="options.eventTypes"
        :eventTypesLoading="options.eventTypesLoading"
        :storeNamespace="storeNamespace"
        @closeForm="stopAdding">
      </EventForm>
    </template>
    <template v-slot:editForm="{ entity, options, stopEditing, entityUpdated }">
      <EventForm
        :event="entity"
        :eventTypes="options.eventTypes"
        :eventTypesLoading="options.eventTypesLoading"
        :storeNamespace="storeNamespace"
        @closeForm="stopEditing">
      </EventForm>
    </template>
    <template v-slot:entityDetails=" { entity }">
      <div class="row mb-2">
        <div class="col-sm-3">
          <div class="list-header">
            Event Type
          </div>
          <div class="list-details">
            {{getEventTypeName(entity.eventTypeId)}}
          </div>
        </div>
        <div class="col-sm-3">
          <div class="list-header">
            Event Date
          </div>
          <div class="list-details">
            {{entity.date | dateString}}
          </div>
        </div>
        <div class="col-sm-6">
          <div class="list-header">
            Event Notes
          </div>
          <div class="list-details notes-field">{{entity.notes || 'None'}}</div>
        </div>
      </div>
    </template>
  </BaseListCard>
</template>
<script>
import { mapState } from 'vuex';
import BaseListCard from '../common/BaseListCard.vue';
import CollapseParent from '@/mixins/CollapseParent';
import EventForm from './EventForm.vue';
import { EntityModules } from '@/store/moduleConfig';
import EventDateHelper from '../../mixins/EventDateHelper';

export default {
  name: 'EventCard',
  props: [
    'parentId',
    'parentType',
    'parentTitle',
    'eventTypes',
    'eventTypesLoading',
    'entities',
    'entitiesLoading',
  ],
  components: {
    BaseListCard,
    EventForm,
  },
  mixins: [CollapseParent, EventDateHelper],

  computed: {
    storeNamespace() {
      if (this.parentType === 'instrument') {
        return EntityModules.INSTRUMENT_EVENT.namespace;
      }
      return EntityModules.SERVICE_EVENT.namespace;
    },
    ...mapState('User', {
      user: state => state.user,
    }),
  },
  methods: {
    entitySort(a, b) {
      const aDate = new Date(a.date);
      const bDate = new Date(b.date);
      return (bDate.getYear() - aDate.getYear())
        || (bDate.getMonth() - aDate.getMonth())
        || (bDate.getDate() - aDate.getDate())
        || (b.id - a.id);
    },
    emptyEntity(parentId) {
      let instrumentId = null;
      let serviceId = null;
      if (this.parentType === 'instrument') {
        instrumentId = parentId;
      } else {
        serviceId = parentId;
      }

      return {
        instrumentId,
        serviceId,
        eventTypeId: '',
        notes: null,
        date: null, // this.getEventDate(),
      };
    },

    deleteEntity(entity) {
      this.$store.dispatch(
        `${this.storeNamespace}/deleteEntity`, {
          entityType: 'event',
          entity,
        },
      ).then(() => {
        this.$store.dispatch('Instrument/forceFetchInstruments',
          this.$store.state.CurrentProject.currentProject.id);
      }).then(() => {
        this.$store.dispatch('Service/forceFetchServicesWithNoLoadingIndicator', parseInt(this.$route.params.project_id, 10));
      });
    },
    getEventTypeName(id) {
      const eventType = this.eventTypes.filter(p => p.id === id)[0];
      return eventType ? eventType.name : 'None';
    },
    deleteDisabled(entity) {
      const eventTypeAdmin = this.eventTypes.filter(p => p.id === entity.eventTypeId)[0];

      return !this.isUserAdmin() && (!eventTypeAdmin || eventTypeAdmin.adminDeleteOnly);
    },
    isUserAdmin() {
      return this.user.idToken.roles.includes('Admin');
    },
  },
};
</script>
